import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import {
    ILabResearchChild,
    // ILabChildOrder,
    // ILabOrder,
    TPrintResponse,
    TResponseGetListResearch,
    type INlabResponse,
} from '../../interfaces/lab.interfaces';
import { LabService } from '../../services/lab.service';

import { HtmlContentPipe } from 'src/app/directives/html-content.pipe';
import { AlertService } from 'src/lib/ariadna/alert';

@Component({
    selector: 'app-reseach-child-modal',
    templateUrl: './reseach-child-modal.component.html',
    styleUrls: ['./reseach-child-modal.component.scss'],
    standalone: false,
    providers: [HtmlContentPipe],
})
export class ReseachChildModalComponent implements OnInit {
    @Input()
    public pickedResearch?: TResponseGetListResearch['researchChildList'][0];
    @Output() public close = new EventEmitter<void>();
    private htmlEncodedObj: Record<string, string> = {
        '&gt;': '> больше',
        '&lt;': '< меньше',
    };

    protected loadingList = false;
    protected reseachChild: Array<ILabResearchChild> = [];

    protected researchBlocks: any[] = [];

    public constructor(
        private lab: LabService,
        private http: HttpNewService,
        private alert: AlertService,
        private htmlContentPipe: HtmlContentPipe,
    ) {}

    @ViewChild('modalBody')
    public modalBody!: ElementRef;
    @ViewChild('header')
    public header!: ElementRef;
    public isMobile: boolean = false;
    public isClosing: boolean = false;

    public ngOnInit(): void {
        this.checkScreenSize();
        this.loadingList = true;
        this.selectOrderChild(this.pickedResearch);
    }

    public ngAfterViewInit() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.addEventListener(
                'scroll',
                this.handleScroll.bind(this),
            );
        }
    }

    public ngOnDestroy() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.removeEventListener(
                'scroll',
                this.handleScroll,
            );
        }
    }
    public handleScroll() {
        if (this.modalBody && this.header) {
            const scrollTop = this.modalBody.nativeElement.scrollTop;

            if (scrollTop > 0) {
                this.header.nativeElement.classList.add('scrolled');
            } else {
                this.header.nativeElement.classList.remove('scrolled');
            }
        }
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.checkScreenSize();
    }

    private checkScreenSize(): void {
        this.isMobile = window.innerWidth <= 767;
    }

    public closeModal(event?: Event): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (this.isMobile) {
            this.isClosing = true;
            setTimeout(() => {
                this.close.emit();
            }, 300); // Match the animation duration
        } else {
            this.close.emit();
        }
    }

    public selectOrderChild(
        order: TResponseGetListResearch['researchChildList'][0] | undefined,
    ) {
        if (!order) {
            console.error('No order provided');
            this.loadingList = false;
            return;
        }

        this.loadingList = true;

        const type = order.extResults
            ? 'ext'
            : order.internalOrder
              ? 'int'
              : 'ext';

        this.lab
            .getLaboratoryChildResearch(null, order.researchId, type)
            .subscribe({
                next: (res) => {
                    this.reseachChild = res;
                    this.processResearchData();
                    this.loadingList = false;
                },
                error: (error) => {
                    console.error('Error loading research data:', error);
                    this.loadingList = false;
                },
            });
    }

    private processResearchData(): void {
        this.researchBlocks = [];
        let currentBlock: any = null;

        this.reseachChild.forEach((child: any, index: number) => {
            child.safeSrvText = child.srvText
                ? this.htmlContentPipe.transform(child.srvText)
                : ''; //название услуги
            child.safeMeasur = child.measur
                ? this.htmlContentPipe.transform(child.measur)
                : ''; //название показателя
            child.safeUnit = child.unit
                ? this.htmlContentPipe.transform(child.unit)
                : ''; //единица измерения

            child.safeText = child.text
                ? this.htmlContentPipe.transform(child.text)
                : ''; // результат
            child.cleanTextLength = child.text
                ? child.text
                      .replace(/&lt;/g, '<')
                      .replace(/&gt;/g, '>')
                      .replace(/<br\s*\/?>/gi, '').length
                : 0;

            child.safeNorm = child.norm
                ? this.htmlContentPipe.transform(child.norm)
                : ''; //норма исследования

            child.safeNormNote = child.normNote
                ? this.htmlContentPipe.transform(child.normNote)
                : ''; //комментарий к норме

            child.safeNotes = child.notes
                ? this.htmlContentPipe.transform(child.notes)
                : ''; //комментарии (заключения, выводы) к выполненному тесту

            child.safeSpecimenText = child.specimenText
                ? this.htmlContentPipe.transform(child.specimenText)
                : ''; //описание материала, заголовк модалки

            // Определяем, является ли элемент чистым заголовком (информационной строкой без результатов)
            // В JSON у первого элемента: text = " ", result = null, norm = null
            const isPureHeader =
                child.headermark === 1 &&
                (!child.result || child.text.trim() === '');

            if (child.headermark === 1 || index === 0) {
                if (currentBlock) {
                    this.researchBlocks.push(currentBlock);
                }

                currentBlock = {
                    showHeader:
                        index === 0 || (child.headermark === 1 && index === 1),
                    title:
                        child.headermark === 1
                            ? child.safeMeasur
                            : child.safeSrvText,
                    items: [],
                };

                if (isPureHeader) {
                    // Ничего не делаем, пропускаем пуш в items
                } else if (
                    child.headermark === 1 &&
                    child.text &&
                    child.text.length > 15
                ) {
                    currentBlock.items.push(child);
                } else if (child.headermark !== 1) {
                    currentBlock.items.push(child);
                } else if (child.headermark === 1 && child.specimenText) {
                    currentBlock.items.push(child);
                }
            } else {
                currentBlock.items.push(child);
            }
        });

        if (currentBlock) {
            this.researchBlocks.push(currentBlock);
        }
    }
    public decodeUnicode(text: string): string {
        return this.htmlEncodedObj[text];
    }

    public isRotate(dist: string | null): boolean {
        if (!dist) return false;

        return ['&lt;', '!&lt;&lt;'].includes(dist.trim());
    }

    public stringRedact(string: string) {
        if (string.length < 20) {
            return;
        } else {
        }
    }

    public loadingPdfIds: Set<number> = new Set();

    public isNlabResponse(response: TPrintResponse): response is INlabResponse {
        return 'reportList' in response && Array.isArray(response.reportList);
    }

    public async goPdf(
        researchId: number | undefined,
        e: Event,
        ext: number | undefined,
        int: number | undefined,
    ) {
        e.preventDefault();
        e.stopPropagation();
        if (!researchId) return;
        const type: string = ext === 1 ? 'ext' : 'int';

        this.loadingPdfIds.add(researchId);

        try {
            const res = await lastValueFrom(
                this.http.get<TPrintResponse>(
                    this.getDownloadUrlForPDF(researchId, type),
                    null,
                    false,
                ),
            );

            if (res && this.isNlabResponse(res)) {
                const base64 = res.reportList[0].pdf;
                this.printNlab(base64);
                this.printNlab(base64);
                return;
            }

            if (res && !this.isNlabResponse(res)) {
                const binaryString = res.response.data;
                const arrayBuffer = binaryString as ArrayBuffer;
                const bytes = new Uint8Array(arrayBuffer);
                for (let i = 0; i < bytes.length; i++) {
                    bytes[i] = bytes[i];
                }

                const file = new Blob([bytes.buffer], {
                    type: 'application/pdf',
                });
                const fileURL = URL.createObjectURL(file);

                //window.location.href = fileURL;

                // setTimeout(() => URL.revokeObjectURL(fileURL), 10000);

                // // Для Safari на iOS используем создание ссылки
                // const isSafari = /^((?!chrome|android).)*safari/i.test(
                //     navigator.userAgent,
                // );
                // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

                // if (isSafari && isIOS) {
                // делаем скачивание по кнопке для всех устройств
                const link = document.createElement('a');
                link.href = fileURL;
                link.target = '_blank';
                link.rel = 'noopener';
                link.download = `research_${researchId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
                // }
            }
        } catch (error) {
            console.error(error);
            this.alert.error('Ошибка загрузки');
        } finally {
            this.loadingPdfIds.delete(researchId);
        }
    }

    private printNlab(base64: string): void {
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const file = new Blob([bytes.buffer], {
            type: 'application/pdf',
        });
        const fileURL = URL.createObjectURL(file);

        window.location.href = fileURL;

        setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
    }

    public isPdfLoading(researchId: number | undefined): boolean {
        return researchId ? this.loadingPdfIds.has(researchId) : false;
    }

    public getDownloadUrlForPDF(researchId: number | undefined, type: string) {
        return `/labs/pdf/${researchId}.pdf?type=${type}`;
    }
}
